import React from 'react';
import { getTaskPriorityClass } from '../../admin/tasks/quickTaskUtils';
import PersonAvatar from '../avatar/PersonAvatar';

// クイックタスク1件分の行。管理パネルとアーティスト一覧で共有する。
export default function QuickTaskItem({
  title,
  memo = '',
  priority = 'normal',
  dueChip = null,
  assigneeLabel = '',
  assignees = [],
  sourceLabel = '',
  completing = false,
  completed = false,
  onComplete,
  onOpenDetails,
}) {
  const people = Array.isArray(assignees) ? assignees.slice(0, 3) : [];
  const clickable = typeof onOpenDetails === 'function';
  const handleCompleteClick = (event) => {
    event.stopPropagation();
    onComplete?.(event);
  };
  const handleKeyDown = (event) => {
    if (!clickable) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    onOpenDetails();
  };
  const rowClassName = [
    'qt-row',
    getTaskPriorityClass(priority),
    completed ? 'is-completed' : '',
    clickable ? 'is-clickable' : '',
  ].filter(Boolean).join(' ');

  return (
    <div className={rowClassName}>
      <button
        type="button"
        className="qt-row__check"
        onClick={handleCompleteClick}
        disabled={completing || completed}
        aria-label={completed ? '完了済み' : '完了にする'}
        title={completed ? '完了済み' : '完了にする'}
      >
        <i className={`fa-solid ${completing ? 'fa-spinner fa-spin' : 'fa-check'}`} aria-hidden="true" />
      </button>

      <div
        className="qt-row__content"
        role={clickable ? 'button' : undefined}
        tabIndex={clickable ? 0 : undefined}
        onClick={clickable ? onOpenDetails : undefined}
        onKeyDown={handleKeyDown}
      >
        <div className="qt-row__body">
          <span className="qt-row__titleRow">
            <span className="qt-row__dot" aria-hidden="true" />
            <span className="qt-row__title">{title || 'タスク'}</span>
          </span>
          {memo ? <span className="qt-row__memo">{memo}</span> : null}
          {sourceLabel ? (
            <span className="qt-row__source">
              <i className="fa-solid fa-link" aria-hidden="true" />
              {sourceLabel}
            </span>
          ) : null}
        </div>

        <div className="qt-row__meta">
          {dueChip && dueChip.label ? (
            <span className={`qt-due is-tone-${dueChip.tone || 'soon'}`}>{dueChip.label}</span>
          ) : null}
          {assigneeLabel ? (
            <span className="qt-row__assignee">
              {people.length ? (
                <span className="qt-row__avatars" aria-hidden="true">
                  {people.map((person, index) => {
                    const key = `${person?.type || 'person'}:${person?.id || person?.displayName || index}`;
                    return (
                      <PersonAvatar
                        key={key}
                        person={person}
                        role={person?.type}
                        gender={person?.gender}
                        name={person?.displayName}
                        className="qt-row__avatar"
                        size={20}
                        ariaHidden
                      />
                    );
                  })}
                </span>
              ) : (
                <PersonAvatar name={assigneeLabel} className="qt-row__avatar" size={20} ariaHidden />
              )}
              {assigneeLabel}
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
}
